import { cn } from '@/lib/utils'

/**
 * The categorical pill used for every status in the app.
 *
 * One component rather than one per enum: the design system's pill palette is
 * shared, and a second hand-rolled pill is how two statuses end up with
 * different padding. Callers pick the hue; the shape stays here.
 */
export type PillTone =
  | 'gray'
  | 'blue'
  | 'green'
  | 'yellow'
  | 'orange'
  | 'red'
  | 'purple'

const TONE_STYLES: Record<PillTone, string> = {
  gray: 'bg-pill-gray text-pill-gray-text',
  blue: 'bg-pill-blue text-pill-blue-text',
  green: 'bg-pill-green text-pill-green-text',
  yellow: 'bg-pill-yellow text-pill-yellow-text',
  orange: 'bg-pill-orange text-pill-orange-text',
  red: 'bg-pill-red text-pill-red-text',
  purple: 'bg-pill-purple text-pill-purple-text',
}

interface StatusPillProps {
  tone: PillTone
  children: React.ReactNode
  className?: string
}

export function StatusPill({ tone, children, className }: StatusPillProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap',
        TONE_STYLES[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
